import styled from 'styled-components';

/* Przycisk zwiniętego panelu: nazwa aktywnej pozycji i strzałka, wysokość 44 px (cel dotyku). */
export const CollapsibleToggle = styled.button<{ $open: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  min-height: 44px;
  padding: 10px 14px;
  border: 1px solid ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#d1d5db')};
  border-radius: 10px;
  background: ${({ theme }) => (theme.mode === 'dark' ? 'transparent' : '#ffffff')};
  font-family: inherit;
  font-size: 15px;
  text-align: left;
  color: ${({ theme }) => theme.colors.text.primary};
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;

  span {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  strong { font-weight: 600; }

  svg {
    flex-shrink: 0;
    width: 18px;
    height: 18px;
    transition: transform 0.2s ease;
    transform: rotate(${({ $open }) => ($open ? '180deg' : '0deg')});
  }
`;

/* Zawartość popovera: lista pozycji jedna pod drugą, przewijana, gdy jest długa.
   Style list z widoków (na tablecie układane w wiersz) są tu prostowane do kolumny. */
export const CollapsiblePanel = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 2px;
  width: min(360px, calc(100vw - 32px));
  max-height: min(70vh, 520px);
  overflow-y: auto;
  padding: 8px 14px;
  overscroll-behavior: contain;

  nav {
    flex-direction: column !important;
    flex-wrap: nowrap !important;
    overflow: visible !important;
    align-self: stretch !important;
    width: 100%;
    gap: 2px;
  }

  nav > button,
  & > button {
    width: 100%;
    min-height: 44px;
    text-align: left;
    justify-content: flex-start;
  }

  /* Bloki akcji (CTA, „Zarządzaj...") na całą szerokość, bez linii pod spodem. */
  nav > div {
    align-items: stretch !important;
    width: 100%;
  }

  nav > div:last-child {
    border-bottom: none !important;
    padding-bottom: 4px !important;
  }
`;

/* Główna akcja w popoverze (np. „Dodaj kategorię"): ciemna pigułka na całą szerokość. */
export const CollapsibleCta = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  min-height: 44px;
  margin-top: 8px;
  padding: 0 16px;
  border: none;
  border-radius: 9999px;
  background: ${({ theme }) => (theme.mode === 'dark' ? '#f3f4f6' : '#111827')};
  color: ${({ theme }) => (theme.mode === 'dark' ? '#111827' : '#ffffff')};
  font-family: inherit;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;

  svg {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
  }

  &:active {
    transform: scale(0.98);
  }
`;

/* Akcja drugorzędna w popoverze (np. „Zarządzaj kategoriami"): szara pigułka na całą szerokość. */
export const CollapsibleSecondary = styled(CollapsibleCta)`
  margin-top: 0;
  background: ${({ theme }) => (theme.mode === 'dark' ? 'rgba(255, 255, 255, 0.08)' : '#f3f4f6')};
  color: ${({ theme }) => theme.colors.text.primary};
`;
